import React, { useEffect } from "react";
import { FlatList, Text } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  CardStatusColor,
  LoadingLoadMore,
  WrapContent,
  WrapList
} from "../../../components";
import { documentTitle } from "../../../utils";
import { Card } from "../components";

// redux action & types
import { getTripAssign, resetSearchTripValue } from "../../../redux/actions";
import { Reducers } from "../../../redux/types";

const Assign = () => {
  documentTitle("Trip - Assign");
  const dispatch = useDispatch();
  const history = useHistory();
  const tripState = useSelector((state: Reducers) => state.trip);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getTripAssign(false, tripState.searchValue));
  }, [dispatch, tripState.searchValue]);

  const _goToDetailTrip = (id: string, labelStatus: number) => {
    history.push(`/trip-detail/${id}?type=assignment&status=${labelStatus}`, {
      labelStatus
    });
    dispatch(resetSearchTripValue());
  };

  const _statusColor = (status: number) => {
    let color: CardStatusColor = "#50b1b1";
    if (status === 2 || status === 4) {
      color = "#ed5a28";
    }
    return color;
  };

  const _statusDesc = (data: any) => {
    let desc = t("activity.status.draft");

    if (data.status === 2) {
      desc = `SUBMITTED ${data.moderation.stage_current} / ${data.moderation.stage_total}`;
    } else if (data.status === 3) {
      desc = t("activity.status.approved");
    } else if (data.status === 4) {
      desc = t("activity.status.revise");
    } else if (data.status === 5) {
      desc = t("activity.status.ongoing");
    } else if (data.status === 6) {
      desc = t("activity.status.finished");
    } else if (data.status === 7) {
      desc = t("activity.status.canceled");
    }
    return desc;
  };

  return (
    <WrapContent isLoading={tripState.isLoadingListAssign}>
      <WrapList
        isEmpty={tripState.listAssign.length === 0}
        emptyComponent={() => (
          <Text
            style={{ color: "#999999", fontSize: 16, fontFamily: "Poppins" }}
          >
            {t("cash.new.noData")}
          </Text>
        )}
        onEndReached={() =>
          tripState.loadMoreAssign &&
          dispatch(getTripAssign(true, tripState.searchValue))
        }
      >
        <FlatList
          style={{ paddingBottom: 10, paddingHorizontal: 25 }}
          data={tripState.listAssign}
          keyExtractor={(item, index) => index.toString()}
          ListFooterComponent={() => (
            <LoadingLoadMore active={tripState.loadMoreAssign} />
          )}
          renderItem={({ item, index }) => (
            <Card
              item={item}
              index={index}
              withStatus
              statusColor={_statusColor(item.status)}
              statusDesc={_statusDesc(item)}
              onPress={() => _goToDetailTrip(item.id, item.status)}
            />
          )}
        />
      </WrapList>

      {/* {tripState.listAssign.length > 0 && (
        <div
          style={{
            position: "sticky",
            bottom: 0,
            padding: 20,
            paddingTop: 5,
            alignSelf: "flex-end"
          }}
        >
          <Image
            style={{ width: 62.6, height: 75.6 }}
            source={IMAGES.newAssignment}
          />
        </div>
      )} */}
    </WrapContent>
  );
};
export default Assign;
